import Modal from './Modal';
import React from 'react';
import Button from '../Button';
import {
  AlertModalBody,
  AlertModalContainer,
  AlertModalContent,
  AlertModalIconContainer,
  ButtonContainer,
} from './styles';
import { red } from '../../utils/style/colors';
import LocalIcon, { LocalIconTypes } from '../../ui/LocalIcon';
import i18n from '../../i18n';

interface ComponentProps {
  content: any;
  onSubmit: () => void;
  isActive: boolean;
  onCancel?: () => void;
  iconName?: LocalIconTypes;
}

const AlertModal: React.FC<ComponentProps> = ({
  content,
  iconName,
  onSubmit,
  onCancel,
  isActive,
}) => {
  const submitHandler = () => {
    onSubmit();
  };

  const rejectHandler = () => {
    onCancel?.();
  };

  return (
    <AlertModalContainer>
      <Modal
        width="40vw"
        title=""
        onClose={() => {
          /*do nothing*/
        }}
        isActive={isActive}
        isAlert={true}
      >
        <AlertModalBody>
          <AlertModalIconContainer>
            <LocalIcon
              iconName={iconName || 'alert.svg'}
              color={red}
              type="lg"
            />
          </AlertModalIconContainer>
          <AlertModalContent>
            {content || 'Alert Modal Content'}
          </AlertModalContent>
        </AlertModalBody>
        <ButtonContainer>
          <Button color="red" onClick={submitHandler}>
            {i18n.t('delete', { ns: 'survey' }) as string}
          </Button>
          <Button color="white" onClick={rejectHandler}>
            {i18n.t('cancel', { ns: 'survey' }) as string}
          </Button>
        </ButtonContainer>
      </Modal>
    </AlertModalContainer>
  );
};

export default AlertModal;
